import React from 'react';

import { ICampaignProps } from '@domain/interfaces/dashboard/AdsManager/Table/Campaign/ICampaign';
import { ICtr } from '@domain/interfaces/dashboard/AdsManager/AdSenseCampaigns/IAdSenseCampaign';

import { numberFormatter } from '@helpers/masks';

import * as S from './styles';

const Ctr: React.FC<ICampaignProps> = ({ data }) => {
  const ctrData: ICtr = data;

  return (
    <S.Wrapper>
      <S.CtrText>{`${numberFormatter(ctrData.percentage, 2)}%`}</S.CtrText>
    </S.Wrapper>
  );
};

export default Ctr;
